import { render, staticRenderFns } from "./FourthOneForm.vue?vue&type=template&id=39195706&scoped=true&lang=pug&"
import script from "./FourthOneForm.vue?vue&type=script&lang=js&"
export * from "./FourthOneForm.vue?vue&type=script&lang=js&"
import style0 from "./FourthOneForm.vue?vue&type=style&index=0&id=39195706&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39195706",
  null
  
)

export default component.exports